import _slicedToArray from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import Col from "../Grid/Col";
import { Row } from "../Grid/Row";
import SelectState from "./SelectState";
import ZipCodeInput from "./ZipCodeInput";
import * as S from "./styles";
import AutocompleteAddress from "./Address1Input";
import Address2Input from "./Address2Input";
import CityInput from "./CityInput";

function ShippingAddress(e) {
  var t = e.address1,
      a = e.address2,
      l = e.city,
      n = e.state,
      d = e.zipcode,
      c = e.onChanged,
      s = e.apiKey,
      r = e.readonly,
      _useState = useState(t || ""),
      _useState2 = _slicedToArray(_useState, 2),
      o = _useState2[0],
      i = _useState2[1],
      _useState3 = useState(a || ""),
      _useState4 = _slicedToArray(_useState3, 2),
      m = _useState4[0],
      u = _useState4[1],
      _useState5 = useState(l || ""),
      _useState6 = _slicedToArray(_useState5, 2),
      p = _useState6[0],
      f = _useState6[1],
      _useState7 = useState(n || ""),
      _useState8 = _slicedToArray(_useState7, 2),
      E = _useState8[0],
      R = _useState8[1],
      _useState9 = useState(d || ""),
      _useState10 = _slicedToArray(_useState9, 2),
      C = _useState10[0],
      b = _useState10[1];

  useEffect(function () {
    o && p && E && C && Boolean(o && p && E && C) && c({
      address1: o || "",
      address2: m || "",
      city: p || "",
      state: E || "",
      zipcode: C || ""
    });
  }, [o, m, p, E, C]), useEffect(function () {
    t !== o && i(t || "");
  }, [t]), useEffect(function () {
    a !== m && u(a || "");
  }, [a]), useEffect(function () {
    l !== p && f(l || "");
  }, [l]), useEffect(function () {
    n !== E && R(n || "");
  }, [n]), useEffect(function () {
    d !== C && b(d || "");
  }, [d]);
  var A = r;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "search-location-input"
  }, React.createElement(Row, {
    between: "md"
  }, React.createElement(Col, {
    md: 6,
    xs: 12
  }, React.createElement(AutocompleteAddress, {
    label: "Address Line 1",
    value: o,
    onChanged: function onChanged(e, t) {
      i(e), t && (u(t.address2), f(t.city), R(t.state), b(t.zipcode));
    },
    apiKey: s || "",
    disabled: A
  })), React.createElement(Col, {
    md: 6,
    xs: 12
  }, React.createElement(Address2Input, {
    label: "Apt/ Suite/ Unit (Optional)",
    value: m,
    onChanged: function onChanged(e) {
      return u(e);
    },
    disabled: A
  }))), React.createElement(Row, {
    between: "md"
  }, React.createElement(Col, {
    md: 6,
    xs: 12
  }, React.createElement(CityInput, {
    label: "City",
    value: p,
    onChanged: function onChanged(e) {
      return f(e);
    },
    disabled: A
  })), React.createElement(Col, {
    md: 6,
    xs: 12
  }, React.createElement(S.Group, null, React.createElement(S.InputUnit, null, React.createElement(S.Label, null, "State"), React.createElement(SelectState, {
    onChanged: function onChanged(e) {
      return R(e);
    },
    value: E,
    label: "",
    hideLabel: !0,
    disabled: A
  })), React.createElement(S.InputUnit, null, React.createElement(ZipCodeInput, {
    id: "zip-code-input",
    state: E,
    label: "Zip Code",
    value: C,
    onChanged: function onChanged(e) {
      return b(e);
    },
    disabled: A
  })))))));
}

export default ShippingAddress;